import * as React from 'react';
import Divider from '@mui/material/Divider';
import Hero from '../../components/Hero';
import Features from '../../components/Features';
import Highlights from '../../components/Highlights';
import Pricing from '../../components/Pricing';
import ContactUs from '../../components/ContactUs';
import Footer from '../../components/Footer';
import PreviewShowcase from '../../components/PreviewShowcase';
import SectionReveal from '../../components/SectionReveal';

export default function MarketingPage() {
  return (
    <div>
      <Hero />
      <div>
        <SectionReveal>
          <Features />
        </SectionReveal>
        <Divider />
        <SectionReveal delay={60}>
          <PreviewShowcase />
        </SectionReveal>
        <Divider />
        <SectionReveal delay={90}>
          <Highlights />
        </SectionReveal>
        <Divider />
        <SectionReveal delay={120}>
          <Pricing />
        </SectionReveal>
        <Divider />
        <SectionReveal delay={150}>
          <ContactUs />
        </SectionReveal>
        <Divider />
        <Footer />
      </div>
    </div>
  );
}
